import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../../common/DeleteModal";
import { useSelector } from "react-redux";
import { Translate } from "../../../Enums/Tranlate";
import editIcon from "../../../../images/icons/edit.svg";
import trashIcon from "../../../../images/icons/delete.svg";
import ContactUsService from "../../../../services/ContactUsService";

const CardItem = ({ item, index, setShouldUpdate }) => {
	const [deleteModal, setDeleteModal] = useState(false);
	const [messageModal, setMessageModal] = useState(false);
	const navigate = useNavigate();
	const contactUsService = new ContactUsService();
	const lang = useSelector((state) => state.auth?.lang);

	return (
		<tr key={index}>
			<td className="text-wrap-mode">{item?.full_name}</td>
			<td>{item?.email}</td>
			<td>{item?.subject || "-"}</td>
			<td className="text-wrap-mode">
				<i
					style={{
						fontSize: "2rem",
					}}
					className="las la-envelope cursor-pointer"
					onClick={() => setMessageModal(true)}
				/>
			</td>
			<td>
				<div className="d-flex" style={{ gap: "20px" }}>
					{/* <img
						src={editIcon}
						onClick={() => {
							navigate("/projects/edit-project", { state: item });
						}}
						className="cursor-pointer"
						alt="edit"
						width={24}
					/> */}
					<img
						src={trashIcon}
						onClick={() => setDeleteModal(true)}
						className="cursor-pointer"
						alt="trash"
						width={24}
					/>
				</div>
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={item?.full_name}
					deletedItem={item}
					modelService={contactUsService}
					setShouldUpdate={setShouldUpdate}
					onCloseModal={setDeleteModal}
				/>
			)}
			{messageModal && (
				<Modal
					show={messageModal}
					onHide={() => {
						setMessageModal();
					}}>
					<Modal.Body>
						<div className="d-flex justify-content-between">
							<p
								className="mb-0"
								style={{
									fontWeight: "600",
									color: "#333",
									fontSize: "20px",
								}}>
								{Translate[lang]?.message}
							</p>
							<Button
								variant=""
								className="close"
								style={{
									right: lang === "en" ? "0" : "auto",
									left: lang === "ar" ? "0" : "auto",
								}}
								onClick={() => {
									setMessageModal(false);
								}}>
								<span style={{ fontSize: "22px" }}>&times;</span>
							</Button>
						</div>
						<div className="mt-4">{item?.message}</div>
					</Modal.Body>
				</Modal>
			)}
		</tr>
	);
};
export default CardItem;
